/* =========================================
   iZENAY — Cart Drawer
   ========================================= */

(function () {
  'use strict';

  /* ── Money formatting using Shopify's shop.money_format ── */
  var moneyFormat = (window.CartMoneyFormat || '{{ amount }} TL');

  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    var amountNoDecimals = Math.floor(cents / 100);
    var amountComma = amount.replace('.', ',');
    var amountNoDecimalsComma = amountNoDecimals;

    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsComma);
  }

  /* ── Translated strings ── */
  var str = window.CartStrings || {
    title: 'Cart',
    empty: 'Your cart is empty.',
    added: ' added to cart',
    error: 'Error: ',
    generic_error: 'An error occurred, please try again.',
    start_shopping: 'Start Shopping',
    view_cart: 'View Cart',
    checkout: 'Checkout',
    subtotal: 'Subtotal',
    shipping_note: 'Shipping and taxes calculated at checkout.',
    remove: 'Remove'
  };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return (ctx || document).querySelectorAll(sel); }

  /* ── Elements ── */
  var drawer    = qs('#cart-drawer');
  var overlay   = qs('#cart-drawer-overlay');
  var closeBtn  = qs('#cart-drawer-close');
  var itemsEl   = qs('#cart-drawer-items');
  var emptyEl   = qs('#cart-drawer-empty');
  var footerEl  = qs('#cart-drawer-footer');
  var totalEl   = qs('#cart-drawer-total');
  var loadingEl = qs('#cart-drawer-loading');
  var toast     = null;

  if (!drawer) return;

  /* ── Open / Close ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ── Cart icon click → open + refresh ── */
  var cartLinks = qsa('a[href="/cart"], .cart-icon-wrap');
  cartLinks.forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      fetchCart().then(function(cart) {
        renderCart(cart);
        openDrawer();
      });
    });
  });

  /* ── Fetch cart from Shopify AJAX API ── */
  function fetchCart() {
    return fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
    }).then(function(r) { return r.json(); });
  }

  /* ── Add to cart intercept ── */
  function interceptAddToCart() {
    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form.matches('[action*="/cart/add"]') && !form.action.includes('/cart/add')) return;
      e.preventDefault();

      var data = new FormData(form);
      setLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data
      })
      .then(function(r) { return r.json(); })
      .then(function(item) {
        if (item.status) {
          showToast(str.error + item.description);
          setLoading(false);
          return;
        }
        showToast('✓ ' + item.title + str.added);
        return fetchCart();
      })
      .then(function(cart) {
        if (!cart) return;
        renderCart(cart);
        updateCartCount(cart.item_count);
        setLoading(false);
        openDrawer();
      })
      .catch(function() {
        setLoading(false);
        showToast(str.generic_error);
      });
    });
  }

  /* ── Render cart items ── */
  function renderCart(cart) {
    loadingEl.classList.add('is-hidden');

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      emptyEl.style.display = 'flex';
      footerEl.classList.add('is-hidden');
      return;
    }

    emptyEl.style.display = 'none';
    footerEl.classList.remove('is-hidden');
    totalEl.textContent = formatMoney(cart.total_price);

    itemsEl.innerHTML = cart.items.map(function(item, index) {
      var imgHtml = item.image
        ? '<img class="cart-drawer__item-img" src="' + item.image + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '<div class="cart-drawer__item-img-placeholder"></div>';

      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      return [
        '<div class="cart-drawer__item" data-line="' + (index + 1) + '" data-variant-id="' + item.variant_id + '">',
          '<a href="' + item.url + '">' + imgHtml + '</a>',
          '<div class="cart-drawer__item-info">',
            '<p class="cart-drawer__item-vendor">' + escapeHtml(item.vendor) + '</p>',
            '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.title) + '</a>',
            variantHtml,
            '<div class="cart-drawer__item-qty">',
              '<button class="cart-drawer__qty-btn" data-action="decrease" data-line="' + (index + 1) + '" data-qty="' + item.quantity + '">−</button>',
              '<span class="cart-drawer__qty-num">' + item.quantity + '</span>',
              '<button class="cart-drawer__qty-btn" data-action="increase" data-line="' + (index + 1) + '" data-qty="' + item.quantity + '">+</button>',
            '</div>',
          '</div>',
          '<div class="cart-drawer__item-right">',
            '<span class="cart-drawer__item-price">' + formatMoney(item.line_price) + '</span>',
            '<button class="cart-drawer__item-remove" data-line="' + (index + 1) + '" aria-label="' + escapeHtml(str.remove) + '">',
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
            '</button>',
          '</div>',
        '</div>'
      ].join('');
    }).join('');

    bindCartEvents();
  }

  /* ── Bind qty / remove buttons ── */
  function bindCartEvents() {
    qsa('.cart-drawer__qty-btn', itemsEl).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = parseInt(this.dataset.line);
        var qty  = parseInt(this.dataset.qty);
        var action = this.dataset.action;
        var newQty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
        changeQty(line, newQty);
      });
    });

    qsa('.cart-drawer__item-remove', itemsEl).forEach(function(btn) {
      btn.addEventListener('click', function() {
        var line = parseInt(this.dataset.line);
        changeQty(line, 0);
      });
    });
  }

  function changeQty(line, qty) {
    setLoading(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCart(cart);
      updateCartCount(cart.item_count);
      setLoading(false);
    })
    .catch(function() { setLoading(false); });
  }

  /* ── Update cart count badge in header ── */
  function updateCartCount(count) {
    var badge = qs('.cart-count');
    if (!badge) {
      if (count > 0) {
        var wrap = qs('.cart-icon-wrap');
        if (wrap) {
          var b = document.createElement('span');
          b.className = 'cart-count';
          b.textContent = count;
          wrap.appendChild(b);
        }
      }
      return;
    }
    if (count === 0) {
      badge.remove();
    } else {
      badge.textContent = count;
    }
  }

  /* ── Toast ── */
  function showToast(msg) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function() {
      toast.classList.remove('is-visible');
    }, 2800);
  }

  /* ── Loading state ── */
  function setLoading(on) {
    if (on) {
      loadingEl.classList.remove('is-hidden');
    } else {
      loadingEl.classList.add('is-hidden');
    }
  }

  /* ── Escape HTML ── */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ── Init ── */
  interceptAddToCart();

})();
